import { ENVIRONMENT_INITIALIZER, forwardRef, makeEnvironmentProviders } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { BulkOrderComponent } from '../account/bulk-order/bulk-order.component';
import { AccountInformationCentreComponent } from '../account/information-centre/account-information-centre.component';
import { AccountStockLevelReportComponent } from '../account/stock-level-report/account-stock-level-report.component';
import { AccountViewCmsComponent } from '../account/view/account-view-cms.component';
import { WishlistShareComponent } from '../account/wishlist/share/wishlist-share.component';
import { BasketAddNoticeComponent } from '../basket/add-notice/basket-add-notice.component';
import { BasketAddPromoGiftComponent } from '../basket/add-promo-gift/basket-add-promo-gift.component';
import { EcologiBannerBlockComponent } from '../basket/ecologi-banner/ecologi-banner-block.component';
import { MinibasketComponent } from '../basket/minibasket.component';
import { PaymentMethodsLogosBlockComponent } from '../basket/payments-methods-block/payments-methods-logos-block.component';
import { SurchargeInfoBlockComponent } from '../basket/surcharge-info/surcharge-info-block.component';
import { ICmsOutletBlockComponent } from '../catalog/outlet-block/icms-outlet-block.component';
import { CategoryViewLayoutComponent } from '../catalog/ui/category/category-view-layout.component';
import { CategoryHeaderComponent } from '../catalog/ui/category/header/category-header.component';
import { PageComponentFaqAccordionComponent } from '../catalog/ui/listing/faq/faq-accordion.component';
import { PageComponentAddOnsComponent } from '../catalog/ui/page/component/add-ons/add-ons.component';
import { PageComponentAdventCalendarComponent } from '../catalog/ui/page/component/advent-calendar/advent-calendar.component';
import { CmsBlogComponentMoreStoriesComponent } from '../catalog/ui/page/component/blog/component/more-stories/cms-blog-component-more-stories.component';
import { PageComponentPostImageSectionComponent } from '../catalog/ui/page/component/blog/content/post-image-section/post-image-section';
import { PageComponentPostTextSectionComponent } from '../catalog/ui/page/component/blog/content/post-text-section/post-text-section.component';
import { PageComponentCategoriesCarouselComponent } from '../catalog/ui/page/component/categories-carousel/categories-carousel.component';
import { PageComponentCategoryCarouselComponent } from '../catalog/ui/page/component/category-carousel/category-carousel.component';
import { PageComponentCategoryLandingPageHeaderComponent } from '../catalog/ui/page/component/category-landing-page-header/category-landing-page-header.component';
import { PageComponentCollectionPromoComponent } from '../catalog/ui/page/component/collection-promo/collection-promo.component';
import { PageComponentColourSelectorComponent } from '../catalog/ui/page/component/colour-selector/colour-selector.component';
import { PageComponentCountdownBannerComponent } from '../catalog/ui/page/component/countdown-banner/countdown-banner.component';
import { PageComponentCustomformComponent } from '../catalog/ui/page/component/customform/customform.component';
import { PageComponentEditorialFaqComponent } from '../catalog/ui/page/component/editorial-faq/editorial-faq.component';
import { PageComponentEditorialLayoutComponent } from '../catalog/ui/page/component/editorial-layout/editorial-layout.component';
import { PageComponentEditorialComponent } from '../catalog/ui/page/component/editorial/editorial.component';
import { PageComponentFashionRecommendationsComponent } from '../catalog/ui/page/component/fashion-recommendations/fashion-recommendations.component';
import { PageComponentHeroBannerComponent } from '../catalog/ui/page/component/hero-banner/hero-banner.component';
import { PageComponentHeroImageComponent } from '../catalog/ui/page/component/hero-image/hero-image.component';
import { PageComponentHeroValuePropositionBarComponent } from '../catalog/ui/page/component/hero-value-proposition-bar/hero-value-proposition-bar.component';
import { PageComponentHtmlComponent } from '../catalog/ui/page/component/html/html.component';
import { PageComponentContactFormComponent } from '../catalog/ui/page/component/hubspot-contact-form/hubspot-contact-form.component';
import { PageComponentImageQuoteComponent } from '../catalog/ui/page/component/image-quote/image-quote.component';
import { PageComponentImageComponent } from '../catalog/ui/page/component/image/image.component';
import { PageComponentIndexedTextComponent } from '../catalog/ui/page/component/indexed-text/indexed-text.component';
import { PageComponentInstagramFeedProductPageComponent } from '../catalog/ui/page/component/instagram-feed-product-page/instagram-feed-product-page.component';
import { PageComponentInstagramFeedComponent } from '../catalog/ui/page/component/instagram-feed/instagram-feed.component';
import { PageComponentLinksComponent } from '../catalog/ui/page/component/links/links.component';
import { PageComponentMentionMeComponent } from '../catalog/ui/page/component/mention-me/mention-me.component';
import { PageComponentMenuComponent } from '../catalog/ui/page/component/menu/menu.component';
import { PageComponentNewsletterComponent } from '../catalog/ui/page/component/newsletter/newsletter.component';
import { PageComponentPopularCategoriesComponent } from '../catalog/ui/page/component/popular-categories/popular-categories.component';
import { PageComponentProductCarouselComponent } from '../catalog/ui/page/component/product-carousel/product-carousel.component';
import { PageComponentQuickLinksComponent } from '../catalog/ui/page/component/quick-links/quick-links.component';
import { PageComponentRowAccordionComponent } from '../catalog/ui/page/component/row-accordion/row-accordion.component';
import { CmsRowComponent } from '../catalog/ui/page/component/row/cms-row.component';
import { PageStoreFinderComponent } from '../catalog/ui/page/component/store-finder/store-finder.component';
import { PageComponentTextHeaderVariant } from '../catalog/ui/page/component/text-header-variant/text-header-variant.component';
import { PageComponentTextComponent } from '../catalog/ui/page/component/text/text.component';
import { PageComponentTrendingComponent } from '../catalog/ui/page/component/trending/trending.component';
import { PageComponentVideoComponent } from '../catalog/ui/page/component/video/video.component';
import { PageComponentZippyContentComponent } from '../catalog/ui/page/component/zippy-content/zippy-content.component';
import { PageComponentAddThisComponent } from '../catalog/ui/product/add-this/add-this.component';
import { ProductBundleOptionsModalComponent } from '../catalog/ui/product/bundle-options/modal/product-bundle-options-modal.component';
import { ProductViewCmsCarouselComponent } from '../catalog/ui/product/cms/carousel/product-view-cms-carousel.component';
import { ProductFeaturesComponent } from '../catalog/ui/product/cms/product-features/component/product-features-cms.component';
import { CmsProductReviewsComponent } from '../catalog/ui/product/cms/product-reviews/cms-product-reviews.component';
import { CmsRelatedProductsComponent } from '../catalog/ui/product/cms/related-products/cms-related-products.component';
import { ProductViewCmsSimpleCarouselBlock } from '../catalog/ui/product/cms/simple-carousel/product-view-cms-simple-carousel.component';
import { ProductViewDeliveryCoutdownComponent } from '../catalog/ui/product/product-view-delivery-coutdown/product-view-delivery-coutdown.component';
import { ProductViewFreeGiftBunnnerComponent } from '../catalog/ui/product/product-view-free-gift-bunner/product-view-free-gift-bunner.component';
import { ProductViewKlarnaMsgBlockComponent } from '../catalog/ui/product/product-view-klarna-msg/product-view-klarna-msg.component';
import { CmsSpecificationSectionItemComponent } from '../catalog/ui/product/specification-section/item/cms-specification-section-item.component';
import { ProductViewSurchargeModalComponent } from '../catalog/ui/product/surcharge/modal/product-view-surcharge-modal.component';
import { ProductViewSurchargeNoteComponent } from '../catalog/ui/product/surcharge/note/product-view-surcharge-note.component';
import { ProductViewLayoutComponent } from '../catalog/ui/product/view-layout/product-view-layout.component';
import { CheckoutAddressModalComponent } from '../checkout/checkout-address-modal/checkout-address-modal.component';
import { CheckoutSuccessLayoutComponent } from '../checkout/success/layout/checkout-success-layout.component';
import { OffCanvasMenuBodyComponent } from '../layout/off-canvas/off-canvas-menu-body.component';
import { LoginFormModalComponent } from '../login/form/modal/login-form-modal.component';
import { LoginFormTradeProspectMessageBlockComponent } from '../login/form/trade/prospect-message/login-form-trade-prospect-message.component';
import { LoginViewLayoutComponent } from '../login/view/layout/login-view-layout.component';
import { AdvancedCommerceRecommendationsComponent } from '../module/advanced-commerce/recommendations/advanced-commerce-recommendations.component';
import { GiftcardsPersonaliseModalComponent } from '../module/giftcards/personalise/modal/giftcards-personalise-modal.component';
import { PaypalPayInThreeMessageComponent } from '../module/paypal-pay-in-three/paypal-pay-in-three-message.component';
import { VipContentComponent } from '../module/vip/vip-content-modal/vip-content-modal.component';
import { MultisiteGeolocationModalComponent } from '../multisite/geolocation/modal/multisite-geolocation-modal.component';
import { MultisiteModalComponent } from '../multisite/modal/multisite-modal.component';
import { MultisiteSwitchModalComponent } from '../multisite/switch/modal/multisite-switch-modal.component';
import { SearchOutletBlockComponent } from '../search/ui/outlet/search-outlet-block.component';
import { BasketTotalModalComponent } from './modal/basket-total/basket-total-modal.component';
import { ProductSizeGuideModalComponent } from './modal/product-size-guide/product-size-guide-modal.component';

const components = [
    SearchOutletBlockComponent,
    MultisiteSwitchModalComponent,
    MultisiteModalComponent,
    MultisiteGeolocationModalComponent,
    VipContentComponent,
    PaypalPayInThreeMessageComponent,
    AdvancedCommerceRecommendationsComponent,
    LoginViewLayoutComponent,
    LoginFormTradeProspectMessageBlockComponent,
    LoginFormModalComponent,
    OffCanvasMenuBodyComponent,
    ProductSizeGuideModalComponent,
    BasketTotalModalComponent,
    forwardRef(() => CheckoutSuccessLayoutComponent),
    CheckoutAddressModalComponent,
    forwardRef(() => ProductViewLayoutComponent),
    ProductViewSurchargeNoteComponent,
    ProductViewSurchargeModalComponent,
    GiftcardsPersonaliseModalComponent,
    CmsSpecificationSectionItemComponent,
    ProductViewKlarnaMsgBlockComponent,
    ProductViewFreeGiftBunnnerComponent,
    ProductViewDeliveryCoutdownComponent,
    ProductViewCmsSimpleCarouselBlock,
    CmsRelatedProductsComponent,
    CmsProductReviewsComponent,
    ProductFeaturesComponent,
    ProductViewCmsCarouselComponent,
    ProductBundleOptionsModalComponent,
    PageComponentAddThisComponent,
    PageComponentContactFormComponent,
    PageComponentZippyContentComponent,
    PageComponentVideoComponent,
    PageComponentTrendingComponent,
    BulkOrderComponent,
    AccountInformationCentreComponent,
    AccountStockLevelReportComponent,
    AccountViewCmsComponent,
    WishlistShareComponent,
    MinibasketComponent,
    BasketAddNoticeComponent,
    BasketAddPromoGiftComponent,
    EcologiBannerBlockComponent,
    PaymentMethodsLogosBlockComponent,
    SurchargeInfoBlockComponent,
    ICmsOutletBlockComponent,
    CategoryViewLayoutComponent,
    CategoryHeaderComponent,
    PageComponentFaqAccordionComponent,
    PageComponentAddOnsComponent,
    PageComponentAdventCalendarComponent,
    CmsBlogComponentMoreStoriesComponent,
    PageComponentPostImageSectionComponent,
    PageComponentPostTextSectionComponent,
    PageComponentCategoriesCarouselComponent,
    PageComponentCategoryCarouselComponent,
    PageComponentCategoryLandingPageHeaderComponent,
    PageComponentCollectionPromoComponent,
    PageComponentColourSelectorComponent,
    PageComponentCountdownBannerComponent,
    PageComponentCustomformComponent,
    PageComponentEditorialComponent,
    PageComponentEditorialFaqComponent,
    PageComponentEditorialLayoutComponent,
    PageComponentFashionRecommendationsComponent,
    PageComponentHeroBannerComponent,
    PageComponentHeroImageComponent,
    PageComponentHeroValuePropositionBarComponent,
    PageComponentHtmlComponent,
    PageComponentImageComponent,
    PageComponentImageQuoteComponent,
    PageComponentIndexedTextComponent,
    PageComponentInstagramFeedComponent,
    PageComponentInstagramFeedProductPageComponent,
    PageComponentLinksComponent,
    PageComponentMentionMeComponent,
    PageComponentMenuComponent,
    PageComponentNewsletterComponent,
    PageComponentPopularCategoriesComponent,
    PageComponentProductCarouselComponent,
    PageComponentQuickLinksComponent,
    CmsRowComponent,
    PageComponentRowAccordionComponent,
    PageStoreFinderComponent,
    PageComponentTextComponent,
    PageComponentTextHeaderVariant
];

export const provideCmsComponents = () => {
    return makeEnvironmentProviders([
        {
            provide: ENVIRONMENT_INITIALIZER,
            useFactory: () => () => {
                return surviveTreeShaking(components);
            },
            multi: true
        }
    ]);
};
